import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  // Déclaration du formulaire et des variables
  changePasswordForm: FormGroup;
  token: string | null = null; // Stocke le token extrait de l'URL
  message: string = ''; // Message de retour pour l'utilisateur

  constructor(
    private fb: FormBuilder, // Utilisé pour la création du formulaire réactif
    private authService: AuthService, // Service d'authentification pour gérer le changement de mot de passe
    private route: ActivatedRoute, // Pour récupérer les paramètres de l'URL
    private router: Router // Pour naviguer après un changement réussi
  ) {
    // Initialisation du formulaire réactif avec les validations
    this.changePasswordForm = this.fb.group({
      newPassword: ['', [Validators.required, Validators.minLength(8)]], // Nouveau mot de passe
      confirmPassword: ['', [Validators.required, Validators.minLength(8)]] // Confirmation du mot de passe
    }, {
      validator: this.passwordMatchValidator // Valide si les mots de passe correspondent
    });
  }

  ngOnInit() {
    // Extraction du token de l'URL
    const rawToken = this.route.snapshot.paramMap.get('token'); // Récupère le token brut depuis les paramètres
    if (rawToken) {
      this.token = rawToken.replace(/^b'/, '').replace(/'$/, ''); 
      console.log(this.token)// Nettoie le token (supprime `b'` et `'`)
    } else {
      // Si aucun token n'est présent, redirection ou affichage d'une erreur
      this.message = 'Token non valide ou manquant.';
    }
  }

  // Validation de la correspondance des mots de passe
  passwordMatchValidator(formGroup: FormGroup) {
    const newPassword = formGroup.get('newPassword');
    const confirmPassword = formGroup.get('confirmPassword');
    if (newPassword && confirmPassword && newPassword.value !== confirmPassword.value) {
      confirmPassword.setErrors({ mismatch: true });
    } else {
      confirmPassword?.setErrors(null);
    }
  }

  // Fonction appelée lors de la soumission du formulaire
  onChangePasswordSubmit() {
    if (this.changePasswordForm.valid && this.token) {
      const data = {
        new_password: this.changePasswordForm.value.newPassword, // Nouveau mot de passe
        confirm_new_password: this.changePasswordForm.value.confirmPassword // Confirmation du mot de passe
      };

      // Appel au service pour changer le mot de passe
      this.authService.changePassword(this.token, data).subscribe(
        (response) => {
          // En cas de succès, affichage du message et redirection
          this.message = 'Mot de passe changé avec succès.';
          this.router.navigate(['/login']);
        },
        (error) => {
          // Gestion des erreurs
          this.message = error?.error?.message || 'Une erreur est survenue. Veuillez réessayer.';
        }
      );
    } else {
      // Si le formulaire est invalide ou si le token est manquant
      this.message = 'Formulaire invalide ou token manquant.';
    }
  }
}
